import { Component, input, inject, type AfterViewInit, effect, type OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { LoaderService } from './loader.service';

@Component({
  selector: 'lib-loader',
  imports: [],
  templateUrl: './app-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./app-loader.component.css']
})
export class AppLoaderComponent implements AfterViewInit, OnDestroy {
  readonly message = input<string>('');
  private readonly loaderService = inject(LoaderService);
  readonly visible = this.loaderService.isLoading;
  private bodyOverflow: string | null = null;

  constructor() {
    effect(() => {
      if (this.visible()) {
        this.bodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      } else if (this.bodyOverflow !== null) {
          document.body.style.overflow = this.bodyOverflow;
          this.bodyOverflow = null;
        }
    });
  }

  public ngAfterViewInit(): void {
    // Ensure scroll lock is applied if already visible on init
    if (this.visible()) {
      document.body.style.overflow = 'hidden';
    }
  }

  public ngOnDestroy(): void {
    // Restore scroll on destroy
    if (this.bodyOverflow !== null) {
      document.body.style.overflow = this.bodyOverflow;
    }
  }
}
